import * as React from  'react';


interface ParentProps {
  
  showLoader: boolean;
  
  
}



export class Loading extends React.Component<ParentProps> {
  state: ParentProps = {
    showLoader: this.props.showLoader,
    

  };

  showLoader = () => {
    this.setState({ showLoader: true})
  }
  
  removeLoader = () => {
    this.setState({ showLoader: false})
  }
  
  
  

  render() {
   
    return (
      <div>

        {this.state.showLoader ?<div className='loadingBot'> </div>
         
          : ''}

      </div>
    );
  }
}
export default Loading;
